import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Icon, Haldor__Block, addBlockTranslations } from '@haldor/ui';
import OnedrivePicker from './OnedrivePicker';
import './_FileBlock.scss';

var FileBlock = /*#__PURE__*/function (_Haldor__Block) {
  _inherits(FileBlock, _Haldor__Block);

  var _super = _createSuper(FileBlock);

  function FileBlock(_props) {
    var _this;

    _classCallCheck(this, FileBlock);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "selectFile", function (files) {
      if (files != null && files.length > 0) {
        var resources = _this.getResources();

        files.forEach(function (file) {
          var foundInResources = resources.findIndex(function (resource) {
            return resource.name == file.name;
          });

          if (foundInResources < 0) {
            _this.addResource('haldor.blocks.file.fileItem', file);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "edit", function (props) {
      return /*#__PURE__*/React.createElement("div", {
        className: "block--fileblock edit"
      }, props.resources.length > 0 ? props.resources.map(function (resource) {
        return /*#__PURE__*/React.createElement("div", {
          className: "file-resource",
          key: resource.name
        }, /*#__PURE__*/React.createElement("div", {
          className: "name"
        }, resource.name), /*#__PURE__*/React.createElement("span", {
          className: "delete-resource",
          onClick: function onClick(e) {
            return _this.removeResource(resource);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Bin"
        })));
      }) : null, /*#__PURE__*/React.createElement(OnedrivePicker, {
        onUpdate: _this.selectFile
        /* openPicker={callback => this.editorBlockWasAdded = callback} */

      }));
    });

    _defineProperty(_assertThisInitialized(_this), "consume", function (props) {
      var resources = [];

      if (props.resources != null && props.resources.length > 0) {
        resources = _toConsumableArray(props.resources).sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "block--fileblock consume"
      }, resources.map(function (resource) {
        return /*#__PURE__*/React.createElement("a", {
          className: "file-resource",
          href: resource.url,
          target: "_blank",
          key: resource.name
        }, /*#__PURE__*/React.createElement("div", {
          className: "name"
        }, resource.name));
      }));
    });

    _this.name = 'Haldor.Blocks.File';
    _this.order = 48;

    _this.icon = function () {
      return /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w2.org/2000/svg",
        viewBox: "0 0 50 50",
        dangerouslySetInnerHTML: {
          __html: "\n\t\t\t\t\t\t<defs><style>.icon-block-file-1{fill:#c8c9c8;}</style></defs>\n\t\t\t\t\t\t<path class=\"icon-block-file-1\" d=\"M30.92,32.9H19.08a2,2,0,1,0,0,4H30.92a2,2,0,1,0,0-4Z\"/>\n\t\t\t\t\t\t<path class=\"icon-block-file-1\" d=\"M19.08,29H25A2,2,0,0,0,25,25H19.08a2,2,0,1,0,0,3.95Z\"/>\n\t\t\t\t\t\t<path class=\"icon-block-file-1\" d=\"M40.28,17.75,29.54,5.91a2,2,0,0,0-1.46-.65H14.26a5,5,0,0,0-5,4.93h0V39.81a5,5,0,0,0,5,4.93H35.74a5,5,0,0,0,5-4.93h0V19.08A2,2,0,0,0,40.28,17.75ZM29,11.18l5.41,5.92H30.41A1.55,1.55,0,0,1,29,15.45V11.18Zm6.79,29.61H14.26a1,1,0,0,1-1.11-1h0V10.19a1,1,0,0,1,1.11-1H25v6.21a5.5,5.5,0,0,0,5.35,5.63h6.5V39.81a1,1,0,0,1-1.11,1Z\"/>\n\t\t\t\t\t"
        }
      });
    };

    addBlockTranslations('sv-se', [{
      output: 'Filer',
      id: 'Haldor.Blocks.File'
    }]);
    addBlockTranslations('en-us', [{
      output: 'Files',
      id: 'Haldor.Blocks.File'
    }]);
    addBlockTranslations('nb-no', [{
      output: 'Filer',
      id: 'Haldor.Blocks.File'
    }]);
    addBlockTranslations('da-dk', [{
      output: 'Filer',
      id: 'Haldor.Blocks.File'
    }]);
    addBlockTranslations('uk', [{
      output: 'Файли',
      id: 'Haldor.Blocks.File'
    }]);

    _this.registerResourceType('haldor.blocks.file.fileItem', {
      id: 'number',
      name: 'string',
      type: 'string',
      url: 'string'
    });

    _this.editorBlockWasAdded = null;
    return _this;
  }

  return _createClass(FileBlock);
}(Haldor__Block);

export default FileBlock;